<template>
  <div>
    {{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute"
           width="100%">
      <tr height="48px" max-height="48px">
        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'Imprimir Etiquetas Código de Barra'"
                       :titulo="'Código de Barra'" @MethodAnular="anular" @MethodEliminar="remove"
                       @MethodEtiquetaXFactura="EtiquetaXFactura"
                       @MethodGuardar="save" @MethodImprimir="imprimirList" @MethodNuevo="newwnuevo"
                       @abrirBarraTablaDinamica="abrirTabla" />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle></v-btn-toggle>
                  <v-btn color="yellow accent-4" small width="95%" @click.prevent="actualiza_tb_ver">
                    <i class="fa fa-eye" style="font-size: 25px"> </i>
                    ver
                  </v-btn>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitINVImprimirEtiquetas'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto"
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">

              <v-card color="grey lighten-3">
                <center>
                  <h3>Imprimir Etiquetas Código de Barra</h3>
                </center>
                <div class="px-2">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <!------------------------------------------- row 1 -->
                    <v-row style="margin-top: -10px">
                      <!------------------------------------------- columna 1 -->
                      <v-col cols="12" md="12" sm="12">
                        <!-------------------------------------------------- Producto -->
                        <v-combobox v-model="form.imprimirEtiqueta.producto" :items="Rproducto" autocomplete="off" dense
                                    item-text="codProDesc"
                                    label="Productos:" no-filter
                                    outlined @blur="SelctCbProduc" @change="changeProducto" @focus="CargarRproducto"
                                    @keyup="CbFilProducto"
                                    >
                          <template slot="item" slot-scope="item">
                            <span style="display:none;">{{
                                item.item.codProDesc = `${item.item.productos.codigo} - ${item.item.productos.descripcion.trim()} ${item.item.unidades.descripcion.trim()} `
                              }}</span>
                            <span
                              class="fontSize13"><b>{{
                                item.item.productos.codigo
                              }}</b> - {{
                                item.item.productos.descripcion.trim()
                              }} <b>{{ item.item.unidades.descripcion.trim() }}</b> </span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span v-if="item.hasOwnProperty('productos')"
                                  class="fontSize13 colorNombre"> <b>{{
                                item.productos.codigo
                              }}</b> - {{ item.productos.descripcion }} {{ item.unidades.descripcion }}  </span>
                          </template>
                          <template v-slot:prepend>
                            <i class="fa fa-shopping-cart" style="font-size: 20px"></i>
                          </template>
                          <template v-slot:append-outer>
                            <v-tooltip v-if="false" top>
                              <template v-slot:activator="{ on }">
                                <v-btn color="green" dark fab x-small v-on="on"
                                       @click.prevent="dialogCrearProducto = true">
                                  <i class="fa fa-plus-square" style="font-size: 20px"></i>
                                </v-btn>
                              </template>
                              <span>Agregar Producto</span>
                            </v-tooltip>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>
                    <!------------------------------------------- fn row 1 -->

                    <!------------------------------------------- row 2 -->
                    <v-row style="margin-top: -25px">
                      <v-col cols="12" md="4" sm="4">
                        <v-text-field label="Codigo" dense outlined v-model="form.imprimirEtiqueta.codigo"
                          :disabled="true" id="formdisabledInput">
                          <template v-slot:prepend>
                            <i style="font-size: 15px" class="fa fa-list-ol"></i>
                          </template>
                        </v-text-field>
                        <!-- ----------------------------- Código Barra -->
                        <v-text-field label="Código Barra:" autocomplete="off" dense outlined
                          v-model="form.imprimirEtiqueta.codigobarra" :disabled="true"
                          id="formdisabledInput">
                          <template v-slot:prepend>
                            <i style="font-size: 15px" class="fa fa-barcode"></i>
                          </template>
                        </v-text-field>

                        <AutoNumeric label="Precio:" dense outlined autocomplete="off"
                          v-model.number="form.imprimirEtiqueta.precio">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px"></i>
                          </template>
                        </AutoNumeric>

                        <AutoNumeric v-model.number="form.imprimirEtiqueta.costo" autocomplete="off" dense
                                     label="Costo:"
                                     outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px"></i>
                          </template>
                        </AutoNumeric>

                        <AutoNumeric label="Beneficio:" dense outlined autocomplete="off"
                          v-model.number="form.imprimirEtiqueta.beneficio">
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px"></i>
                          </template>
                        </AutoNumeric>

                        <!-- ----------------------------- Unidad -->
                        <v-text-field label="Unidad" outlined dense v-model="form.imprimirEtiqueta.unidad" disabled
                        id="formdisabledInput">
                          <template v-slot:prepend>
                            <i style="font-size: 15px" class="fa fa-tachometer"></i>
                          </template>
                        </v-text-field>


                      </v-col>

                      <v-col cols="12" md="4" sm="4">


                        <!-- ----------------------------- suplidor-->
                            <v-combobox autocomplete="off" dense outlined label="suplidor:" :items="RSuplidor"
                          item-text="nombre" v-model="form.imprimirEtiqueta.suplidor" @blur="SelctCbSuplidor"
                          @focus="cargarSuplidor" @keyup="CbFilSuplidor">
                          <template v-slot:prepend>
                            <i class="fa fa-handshake-o" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>
                        <!-- ----------------------------- MONEDA-->
                        <v-combobox id="formdisabledInput" v-model="objMoneda.moneda" :items="Rmoneda"
                                    :rules="[$rules.required]" autocomplete="off"
                                    dense
                                    item-text="descripcion" label="Monedas" outlined
                                    style="font-size:13px;" @blur="SelctCbMoneda"
                                    @change="getChangeMoneda"
                                    @focus="cargarMoneda">

                          <template v-slot:prepend>
                            <i class="fa fa-money" style="font-size: 20px;"></i>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span id="ImputColorDisable">
                      {{ item.descripcion }} ({{ item.nombrecorto }})
                    </span>

                          </template>


                          <template slot="item" slot-scope="item">
                            <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="font-size: 13px;">
                              <p class="pa-0 ma-0 py-0 my-0"><b>{{ item.item.descripcion }} ({{
                                  item.item.nombrecorto
                                }})</b>
                              </p>
                            </v-col>
                          </template>
                        </v-combobox>
                        <!-- ----------------------------- TASA-->
                        <v-text-field v-if="objMoneda.moneda != null" id="formdisabledInput"
                                      v-model.number="objMoneda.tasa" dense label="Tasa"
                                      outlined>
                          <template v-slot:prepend>
                            <i class="fa fa-usd" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                        <!-- ----------------------------- Cantidad -->

                        <v-text-field type="number" label="Cantidad:" dense outlined :rules="[$rules.required]"
                          v-model.number="form.imprimirEtiqueta.cantidad">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-sort-amount-asc"></i>
                          </template>
                        </v-text-field>
                           <!-- ----------------------------- Fecha vencimiento -->
                        <v-text-field dense outlined type="date" label="Fecha vencimiento:"
                          v-model="form.imprimirEtiqueta.fecha" @blur="buscarLote">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>
                         <!-- ----------------------------- Factura-->
                        <v-text-field label="Factura" autocomplete="off" dense outlined
                          v-model="form.imprimirEtiqueta.factura">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-list-alt"></i>
                          </template>
                        </v-text-field>

                      </v-col>

                      <v-col cols="12" md="4" sm="4">

                        <v-text-field v-if="form.imprimirEtiqueta.producto!=null && this.$store.getters.GetConfiguracionGeneral.configInv.usarLote==true" label="Lote" dense outlined
                        v-model="form.imprimirEtiqueta.producto.lote"
                          :disabled="true" id="formdisabledInput">
                          <template v-slot:prepend>
                            <i style="font-size: 15px" class="fa fa-list-ol"></i>
                          </template>
                        </v-text-field>

                        <v-text-field v-if="form.imprimirEtiqueta.producto!=null && this.$store.getters.GetConfiguracionGeneral.configInv.usarLote==true && this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico==true"
                        label="Ultima Sec. Control:" dense outlined v-model.number="form.ultimaSecControl"
                        :disabled="true" id="formdisabledInput">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-sort-amount-asc"></i>
                          </template>
                        </v-text-field>



                        <v-combobox autocomplete="off" dense outlined label="Código de barra:" item-text="descripcion"
                          :items="listEtiquetas" v-model="form.imprimirEtiqueta.formatoBarra" @focus="cargarEtiquetas"
                          @blur="SelctCbEtiquetas">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-barcode"></i>
                          </template>
                        </v-combobox>

                        <!-------------------------------------------------- terminal -->
                        <!--:items="RSuplidor",@blur="SelctCbSuplidor", @focus="cargarSuplidor", @keyup="CbFilSuplidor" -->
                        <v-combobox autocomplete="off" dense outlined label="* Seleccione Impresora:" item-text="nombre"
                          :items="impList" @focus="cargarImpresoras" v-model="form.imprimirEtiqueta.Impresora">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-trademark"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>
                    <!------------------------------------------- fn row 2 -->
                  </v-form>
                </div>
              </v-card>
            </div>
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog v-model="acti_tb_data" label="myAlert" max-height="100%" max-width="100%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"> </i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"> </i>

          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="deep-purple accent-2" dark small v-on="on" @click.prevent="">
                <i class="fa fa-print" style="font-size: 25px"> </i>
                Listado
              </v-btn>
            </template>
            <span>Imprimir Listado</span>
          </v-tooltip>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          ">
            <i class="fa fa-check" style="font-size: 20px"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true" style="margin-top: 20%"
                top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------ Modal- crear Producto-->
    <v-dialog v-model="dialogCrearProducto" label="Modal agregar producto" max-height="80%" max-width="90%"
              persistent transition="fab-transition">
      <CrearProducto @EmitCrearProducto="RecCrearProducto" />
    </v-dialog>

    <!-- ------------------------------------------------------ Modal  Etiqueta-->
    <v-dialog v-model="dialogEtiqueta" label="Modal agregar cuenta" max-height="80%" max-width="90%"
              persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="indigo" dense flat>
          <i class="" style="font-size: 20px"> </i>
          <v-toolbar-title class="font-weight-light" style="color: white">
            Etiquetas X Factura
          </v-toolbar-title>
          <i class="" style="font-size: 20px"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="dialogEtiqueta = false">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br />

          <v-form ref="formEtiqueta" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <!-------------------------------------------------- suplidor -->
                <v-combobox v-model="imprimirEtiquetaXfact.suplidor" :items="RSuplidor" autocomplete="off" dense
                            item-text="nombre" label="suplidor:"
                            outlined @blur="SelctCbSuplidorEtXfact(1)"
                            @focus="cargarSuplidor"
                            @keyup="CbFilSuplidor">
                  <template v-slot:prepend>
                    <i class="fa fa-handshake-o" style="font-size: 20px"></i>
                  </template>
                </v-combobox>

                <v-data-table :headers="[
                  {
                    text: 'FECHA',
                    value: 'fecha',
                    sortable: false,
                    class: ['no-gutters'],
                  },
                  {
                    text: '#FACTURA',
                    value: 'factura',
                    sortable: false,
                    class: ['no-gutters'],
                  },
                  {
                    text: 'VALOR',
                    value: 'valor',
                    sortable: false,
                    class: ['no-gutters'],
                  },
                  {
                    text: 'ACCIÓN',
                    value: 'action',
                    sortable: false,
                    class: ['no-gutters'],
                  },
                ]" :items="imprimirEtiquetaXfact.RListFactura" :items-per-page="15"
                              :server-items-length="imprimirEtiquetaXfact.totalItems" class="elevation-1"
                              dense item-key="codigo"
                              @update:page="SelctCbSuplidorEtXfact">
                  <template v-slot:item.fecha="props">
                    <span style="font-size: 13px">
                      {{ FormatoFecha(props.item.fecha) }}
                    </span>
                  </template>

                  <template v-slot:item.valor="props">
                    <span style="font-size: 13px">
                      {{ currencyFormatter(props.item.total) }}</span>
                  </template>

                  <template v-slot:item.factura="props">
                    <span style="font-size: 13px">
                      {{ props.item.referencia }}</span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn color="blue" fab x-small @click.prevent="ImprimirItemEtiquetaFActura(item)"><i
                      class="fa fa-print" style="font-size: 20px"></i></v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Etiqueta-->

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
import AutoNumeric from "../../components/AutoNumericNuevo"
import CrearProducto from "../../CuentaXPagar/UtilidadComponents/CrearProducto"
import { EventBus } from "../../event-bus"
import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
import ContenidoBase from "../../components/ContenidoBase"
import { currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter } from "@/js/Funciones.js"

export default {
  components: {
    BarraBusqueda2,
    CrearProducto,
    AutoNumeric,
    ContenidoBase,
  },
  data() {
    return {}
  },
  created() {
    var json = {
      titulo: "Código de Barra",
      descripcion: "Imprimir Etiquetas Código de Barra",
      save: true,
      eliminar: true,
      anular: false,
      nuevo: true,
      imprimir: true,
      accion: [
        "INVImprimirEtiquetasNew",
        "INVImprimirEtiquetasSave",
        "INVImprimirEtiquetasRemove",
        "INVImprimirEtiquetasAnular",
        "INVImprimirEtiquetasPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("INVImprimirEtiquetasNew", this.new)
    EventBus.$on("INVImprimirEtiquetasSave", this.save)
    EventBus.$on("INVImprimirEtiquetasRemove", this.remove)
    EventBus.$on("INVImprimirEtiquetasAnular", this.remove)
    EventBus.$on("INVImprimirEtiquetasPrintList", this.imprimirList)
    EventBus.$on("emitINVImprimirEtiquetas", this.datostabla)
    this.cargarTodo()

    EventBus.$on("onResize", this.onResize)
    this.getMonedaBase()
//this.$store.getters.GetConfiguracionGeneral.configInv.usarLote==true"
  },

  data() {
    return {
      ListaTiposClientes: [],
      windowSize: { width: "auto", height: "auto" },

      dialogCrearProducto: false,
      dialogEtiqueta: false,
      listEtiquetas: [],
      imprimirEtiquetaXfact: {
        suplidor: null,
        RListFactura: [],
        totalItems: 0,
      },
      Rmoneda: [],
      objMoneda: {
        moneda: null,
        tasa: null,
      },

      impList: [],
      Rproducto: [],
      RSuplidor: [],

      form: {
        imprimirEtiqueta: {
          codigo: 0,
          producto: null,
          fecha: null,
          factura: "",
          suplidor: null,
          costo: 0,
          beneficio: 0,
          precio: 0,
          codigoBarra: null,
          Impresora: null,
          formatoBarra: null,
          unidad: "",
          cantidad: 0,
        },
        ultimaSecControl:"",
        balancelote:null
      },
      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: true,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: true,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
        etiquetaXfactura: true,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?",
      },

      aalert: {
        estado: false,
        color: null,
      },
    }
  },

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    getParamFecha,
    onResize(e) {
      console.log("imprii ")

      console.log(e)
      this.windowSize = e
    },

    RecCrearProducto(e) {
      this.dialogCrearProducto = e.estado
    },

    cargarEtiquetas() {
      this.$axios
        .get(this.$hostname + this.$hName + "/etiquetas/findall", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.listEtiquetas = res.data))
    },
    cargarImpresoras() {
      var header = {
        mode: "no-cors",
        header: {
          "Access-Control-Allow-Origin": "*",
          "origin": "x-requested-with",
          "Access-Control-Allow-Headers": "POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin",
          "Content-Type": "application/json",
        },
      }
      this.$axios
        .get("http://localhost:15999/impresora/inicial/listaImpresora", header)
        .then((res) => {
          if (res.data.length > 0) {
            this.impList = res.data[0].impresoras
            //this.form.imprimirEtiqueta.Impresora = res.data[0].defaulPrinter;
          }
        })
    },

    SelctCbEtiquetas() {


      var _this = this
      setTimeout(function() {
        if (_this.form.imprimirEtiqueta.formatoBarra == null) {
          _this.form.imprimirEtiqueta.formatoBarra = ""
        }

        if (!_this.form.imprimirEtiqueta.formatoBarra.hasOwnProperty("id")) {
          _this.form.imprimirEtiqueta.formatoBarra = ""
          _this.form.imprimirEtiqueta.formatoBarra = null
          _this.alerta("Seleccione una Barra", "error")
          return
        }
      }, 300)

      /* if (this.form.imprimirEtiqueta.formatoBarra == null) {
         this.form.imprimirEtiqueta.formatoBarra = "";
       }
       if (this.form.imprimirEtiqueta.formatoBarra.id == undefined) {
         this.alerta("Seleccione una Barra", "error");
         this.form.imprimirEtiqueta.formatoBarra = "";
         return;
       }*/
    },

    changeProducto(e){
if(typeof e === "string"){
 var _this = this;
      setTimeout(function () {
      _this.$axios.get( _this.$hostname +_this.$hName +
            "/unidades-productos/" +
            (e.trim() === "" ? "A" : e.trim().replaceAll("/", "*-S-*")) +
            "/false/buscar/true",
            { headers: _this.$store.getters.GetheadersAxios },
          )
          .then((res) => (_this.Rproducto = res.data))

      }, 300)
}

    },
    CbFilProducto(e) {
      //"/false/buscar/true"
      if (e.keyCode!= 13 && e.target.value.trim().length > 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/unidades-productos/" +
            (e.target.value === "" ? "A" : e.target.value.trim().replaceAll("/", "*-S-*")) +
            "/false/buscar/true",
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => (this.Rproducto = res.data))
      }

        //console.log("asjdhjkl-1->", (e.keyCode!= 40 || e.keyCode!=38 || e.keyCode!=37 || e.keyCode!=39))
      
      if(e.target.value.trim().length == 0 && e.keyCode==8){
        this.Rproducto=[]
      }

    },


    SelctCbProduc() {

 /*if (this.form.imprimirEtiqueta.producto == null) {
        this.form.imprimirEtiqueta.producto = "";
      }*/
      var _this = this;
      setTimeout(function () {
        if (_this.form.imprimirEtiqueta.producto== null) {
          _this.form.imprimirEtiqueta.producto= "";
          _this.form.imprimirEtiqueta.fecha=null;
        }
        //!_this.form.imprimirEtiqueta.producto.productos.hasOwnProperty('codigo')
        if (!_this.form.imprimirEtiqueta.producto.hasOwnProperty('productos')) {
         // _this.alerta("Seleccione un producto", "error");
          _this.form.imprimirEtiqueta.producto= "";
          _this.form.imprimirEtiqueta.producto= null;
          //_this.form.imprimirEtiqueta.fecha=null;
          _this.newwnuevo()
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }

        var codigoBarra = _this.form.imprimirEtiqueta.producto.codigobarra!=null ?_this.form.imprimirEtiqueta.producto.codigobarra.trim():"";

        _this.form.imprimirEtiqueta.codigobarra =JSON.parse(JSON.stringify(codigoBarra))
      //  _this.form.imprimirEtiqueta.producto.codigobarra.trim();
        _this.form.imprimirEtiqueta.codigo =
          _this.form.imprimirEtiqueta.producto.productos.codigo
        _this.form.imprimirEtiqueta.precio =
          _this.form.imprimirEtiqueta.producto.precio
        _this.form.imprimirEtiqueta.costo =
          _this.form.imprimirEtiqueta.producto.costo
        _this.form.imprimirEtiqueta.beneficio =
          _this.form.imprimirEtiqueta.producto.porbeneficio
        _this.form.imprimirEtiqueta.unidad =
          _this.form.imprimirEtiqueta.producto.unidades.descripcion

      }, 300)


    },

    cargarSuplidor() {
      this.$axios
        .get(
          this.$hostname + this.$hName + "/proveedores/findallbyDesc/25/0/*",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.RSuplidor = res.data

          console.log("--cargarSuplidor----")
          console.log(res.data)
        })
    },
    SelctCbSuplidor() {
      if (this.form.imprimirEtiqueta.suplidor == null) {
        this.form.imprimirEtiqueta.suplidor = ""
      }
      if (this.form.imprimirEtiqueta.suplidor.codigo == undefined) {
        this.alerta("Seleccione un proveedor", "error")
        this.form.imprimirEtiqueta.suplidor = ""
        return
      }
    },
    buscarLote() {
      if (this.form.imprimirEtiqueta.fecha == null) {
        return
      }
      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/unidades-productos/getLote2/" + this.form.imprimirEtiqueta.fecha,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then(
            (res) =>{
              this.form.imprimirEtiqueta.producto.lote = res.data
            var _this = this;
            setTimeout(function () {
              _this.getUltimaSecControl()
        if (_this.form.imprimirEtiqueta.formatoBarra== null) {
          _this.form.imprimirEtiqueta.formatoBarra= "";
        }

        if (!_this.form.imprimirEtiqueta.formatoBarra.hasOwnProperty('id')) {
          _this.form.imprimirEtiqueta.formatoBarra= "";
          _this.form.imprimirEtiqueta.formatoBarra= null;
            _this.alerta("Seleccione una Barra", "error")
          return;
        }

      }, 300);

            }


          );

      }
    },

getUltimaSecControl(){
     var pro= this.form.imprimirEtiqueta.producto.unidadesProductosPK.producto
     var uni= this.form.imprimirEtiqueta.producto.unidadesProductosPK.unidad
     var lote= parseInt(this.form.imprimirEtiqueta.producto.lote)

var LINK=`${pro}/${uni}/${lote}`
this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/getUltimaSecControl/" + LINK, {
                headers: this.$store.getters.GetheadersAxios,
              })
                .then((res) => {
                  if(typeof res.data==='string'){
                    this.alerta("El producto seleccionado junto al lote, no se ha realizado una entrada de inventario.", "error")
                    this.form.ultimaSecControl=""
                  }
                  if(typeof res.data==='object'){
                  this.form.balancelote=res.data
                  this.form.ultimaSecControl=res.data.control.trim()
                  }
                  
                  
                  // this.ListaProdxLote = ObjList
                })
                .catch((error) => { console.log('Catch---') });
    },

 updateUltimaSecControl(BALANCE_LOTE){
 var NEW_CONTROL=this.getSecuenciaAlfNum()
 BALANCE_LOTE.control=NEW_CONTROL
this.$axios.post(this.$hostname + this.$hName + "/unidades-productos/updateUltimaSecControl",
              BALANCE_LOTE,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {
                this.form.ultimaSecControl=NEW_CONTROL
            })
            .catch(error => {
              if (error.response) {
                console.log('ERROR-CATCH-->',error.response.data)
               // this.alerta(error.response.data, "error")
              } else if (error.request) {
                console.log('ERROR-CATCH-->',error.request)
                //this.alerta(error.request, "error")
              } else {
                console.log('ERROR-CATCH-->',error.message)
               // this.alerta(error.message, "error")
              }
            })
    },


    SelctCbSuplidorEtXfact(facturaPage) {
      if (this.imprimirEtiquetaXfact.suplidor == null) {
        this.imprimirEtiquetaXfact.suplidor = ""
      }
      if (this.imprimirEtiquetaXfact.suplidor.codigo == undefined) {
        this.alerta("Seleccione un suyplidor", "error")
        this.imprimirEtiquetaXfact.suplidor = ""
        return
      }
      this.findFacturas(this.imprimirEtiquetaXfact.suplidor.codigo, facturaPage - 1)
    },

    findFacturas(proveedor, facturaPage) {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          `/facturasproveedor/findListFactProveedorPlus/15/${facturaPage * 15}/null/` +
          proveedor +
          "/null/null/null",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
            this.imprimirEtiquetaXfact.RListFactura = res.data.ListItems
            this.imprimirEtiquetaXfact.totalItems = res.data.TbTotalItem
          },
        )
    },

    CbFilSuplidor(e) {
      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/proveedores/findallbyDesc/25/0/" +
            (e.target.value === "" ? "*" : e.target.value),
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => (this.RSuplidor = res.data))
      }
    },

    CargarRproducto() {
      this.$axios
        .get(
          this.$hostname + this.$hName + "/unidades-productos/*/false/buscar/false",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => (this.Rproducto = res.data))
        .catch((er) => console.log(er))
    },

    NumeralFac(e) {
      if (e.key) {
        var mynumeral = require("numeral")
        this.form.imprimirEtiqueta.factura = mynumeral(
          this.form.imprimirEtiqueta.factura,
        ).value()
        //console.log(mynumeral(""+this.form.imprimirEtiqueta.factura)).value()
        if (this.form.imprimirEtiqueta.factura == null) {
          this.form.imprimirEtiqueta.factura = 0
        }
      } else {
        console.log("no se puede poner letras o signos")
      }
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
    },
    async cargarTodo() {
    },
    datostabla(e) {
      this.unidades = e
      this.acti_tb_data = false
    },
    save() {
    },
    remove() {
      if (this.unidades.codigo != 0 && this.unidades.codigo != null) {
        this.Elim_notif.estado = !this.Elim_notif.estado
      } else {
        this.alerta("Seleccione un tipo de cliente para eliminar", "error")
      }
    },
    eliminar() {
    },
    anular() {
    },

    imprimirList() {

      

       if (this.form.imprimirEtiqueta.producto==null) {
        this.alerta("Debe Seleccionar un producto!!", "error")
        return
      }
      
      if (this.form.imprimirEtiqueta.cantidad <= 0) {
        this.alerta("Debe digitar la cantidad de etiqueta que desea imprimir!!", "error")
        return
      }
      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
        if (this.form.imprimirEtiqueta.fecha == null || this.form.imprimirEtiqueta.fecha.toString().length == 0) {
          this.alerta("Al estar usando lote debe registrar la fecha de vencimiento en cada etiqueta!!", "error")
          return
        }
      }

      if (this.form.imprimirEtiqueta.formatoBarra == null) {
        this.alerta("Debe selecionar un formato de etiqueta", "error")
        return
      }
      if (this.form.imprimirEtiqueta.Impresora == null) {
        this.alerta("Debe selecionar una impresora para imprimir", "error")
        return
      }

      var BOOL_DIST_FARM=this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico
       if (BOOL_DIST_FARM==true && this.form.imprimirEtiqueta.producto.productos.empresa==null) {
        this.alerta("El producto seleccionado no posee un tipo de factura asignado!!", "error")
        return
       }

      
      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote === true) {
        this.$axios.get(this.$hostname + this.$hName + "/fechaVencimiento/findByFecha/" + this.form.imprimirEtiqueta.fecha.trim().substr(0, 10) + "T04:00",
          { headers: this.$store.getters.GetheadersAxios },
        )
          .then((res) => {
            /*t.lote = res.data.codigo
            console.log(t.fechavencimiento);*/
            var codigoLote = ("0000" + res.data.codigo).substring(("0000" + res.data.codigo).length - 4, ("0000" + res.data.codigo).length)
            this.imprimirListCont(codigoLote)
          })
          .catch(error => {
            let msg = ""
            if (error.response) {
              msg = error.response.data
            } else if (error.request) {
              msg = error.request.data
            } else {
              msg = error.message
            }
            this.alerta(msg, "error")
          })

      } else {
        this.imprimirListCont(null)
      }


    },


    imprimirListCont(LOTE) {

      // this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/findUnidadMinimaCompra/" + this.form.imprimirEtiqueta.codigo + '/' + !this.form.imprimirEtiqueta.producto.unidadminima, { headers: this.$store.getters.GetheadersAxios })
      this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/findUnidadMinimaCompra/" + this.form.imprimirEtiqueta.codigo + "/" + !this.form.imprimirEtiqueta.producto.unidadminima, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.form.imprimirEtiqueta.config = this.$store.getters.GetConfiguracionGeneral
          this.form.imprimirEtiqueta.productoOpuesto = res.data
          console.log(this.form.imprimirEtiqueta)
          var Obj = JSON.parse(JSON.stringify(this.form.imprimirEtiqueta))
          Obj.producto = JSON.parse(JSON.stringify(this.form.imprimirEtiqueta.productoOpuesto))
          Obj.productoOpuesto = JSON.parse(JSON.stringify(this.form.imprimirEtiqueta.producto))
          if (LOTE != null) {
            Obj.producto.lote = LOTE
          }
          Obj.monedaSelect = {
            tasaSelect: this.objMoneda.tasa,
            modedacorto: this.objMoneda.moneda.nombrecorto.trim(),
          }
          var BOOl = (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote==true && this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico==true)
          if(BOOl==true){
              Obj.cantRepetir=JSON.parse(JSON.stringify(this.form.imprimirEtiqueta.cantidad))
              Obj.cantidad=1
              Obj.ultimaSecControl=JSON.parse(JSON.stringify(this.form.ultimaSecControl))
              Obj.balancelote=this.form.balancelote
              this.imprimir(Obj, "etiquetaDistFarmaceutico");
              /*console.log('OBJ-->',Obj)
              this.getSecuenciaAlfNum()*/
          }else{
           this.imprimir(Obj, "etiqueta")
          }

        })

    },


    imprimir(datos, operacion) {
      EventBus.$emit("loading", true)
      datos.operacion = operacion
      this.$axios
        .post("http://localhost:15999/impresora/imprimir", datos)
        .then((res) => {
          EventBus.$emit("loading", false)
          //this.limpiarPuntoVentaCompleto();
          if(operacion.includes('etiquetaDistFarmaceutico')){
            this.updateUltimaSecControl(datos.balancelote)
          }
        })
        .catch((error) => {
          EventBus.$emit("loading", false)
          console.error(error)
        })

    },
    EtiquetaXFactura() {

      if (this.form.imprimirEtiqueta.cantidad <= 0) {
        this.alerta("Debe digitar la cantidad de etiqueta que desea imprimir!!", "error")
        return
      }
      if (this.form.imprimirEtiqueta.formatoBarra == null) {
        this.alerta("Debe selecionar un formato de etiqueta", "error")
        return
      }
      if (this.form.imprimirEtiqueta.Impresora == null) {
        this.alerta("Debe selecionar una impresora para imprimir", "error")
        return
      }
      this.imprimirEtiquetaXfact.RListFactura = []
      this.imprimirEtiquetaXfact.suplidor = null
      this.dialogEtiqueta = true
      console.log("Entrando a EtiquetaXFactura")
    },

    ImprimirItemEtiquetaFActura(e) {
      var ListBalancLote=[]
      console.log('ImprimirItemEtiquetaFActura-->',e)
      if (e != null) {
        e.facturasProveedoresDetalleList.forEach((element) => {
          if (element.productos.imprimirEtiqueta) {
            this.$axios
              .get(
                this.$hostname + this.$hName + "/unidades-productos/find/" + element.productos.codigo + "/" + element.unidades.codigo,
                { headers: this.$store.getters.GetheadersAxios },
              )
              .then((res) => {

                var UNI_MINI = null
                var bar = new Promise((resolve, reject) => {
                  if (res.data.unidadminima == false) {
                    this.$axios.get(this.$hostname + this.$hName + "/unidades-productos/findUnidadMinimaCompra/" + element.productos.codigo + "/true",
                      { headers: this.$store.getters.GetheadersAxios })
                      .then((ress) => {
                        UNI_MINI = ress.data
                        resolve()
                      })

                  } else {
                    UNI_MINI = res.data
                    resolve()
                  }
                })


                bar.then(() => {

                  if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {

                  // this.$hostname + this.$hName + "/unidades-productos/getLote/" + res.data.fechavencimiento,
                  var LINK=this.$hostname + this.$hName + "/unidades-productos/getLote2/" +  element.nuevaFechaVencimiento
                  var BOOl = (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote==true && this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico==true)
                  if(BOOl==true){
                        var pro= element.productos.codigo
                        var uni= element.unidades.codigo
                        var lote= element.lote
                        LINK=`${this.$hostname+this.$hName}/unidades-productos/getLote2Control/${element.nuevaFechaVencimiento}/${pro}/${uni}/${lote}`
                  }
                  this.$axios
                    .get(
                      LINK,
                      { headers: this.$store.getters.GetheadersAxios }
                    )
                    .then((loteControl) => {
                      var resultado = {};
                      resultado.config = this.$store.getters.GetConfiguracionGeneral;
                      resultado.suplidor = this.imprimirEtiquetaXfact.suplidor;
                      resultado.cantidad = element.cantidad;
                      resultado.producto = res.data;
                      resultado.producto.lote = loteControl.data.lote;
                      resultado.factura = e.referencia;
                      resultado.unidad = element.unidades.descripcion;
                      resultado.formatoBarra = this.form.imprimirEtiqueta.formatoBarra;
                      resultado.Impresora = this.form.imprimirEtiqueta.Impresora;
                      resultado.productoOpuesto = UNI_MINI;

        var BOOl = (this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico==true)
          if(BOOl==true){
              resultado.cantRepetir=JSON.parse(JSON.stringify(element.cantidad))
              resultado.cantidad=1
              var SEC=loteControl.data.BalanceLote.control.trim().length>0?loteControl.data.BalanceLote.control.trim():"AA0000"
              resultado.ultimaSecControl=JSON.parse(JSON.stringify(SEC))
              var CANT= element.cantidad>0?element.cantidad:1;
              var OBJ_BAC_LOT=JSON.parse(JSON.stringify(loteControl.data.BalanceLote))
              OBJ_BAC_LOT.control=this.generarSecuencia(SEC,CANT).nuevaSecuencia;
              resultado.balancelote=OBJ_BAC_LOT
             // ListBalancLote.push(OBJ_BAC_LOT)
               this.imprimir(resultado, "etiquetaDistFarmaceutico");
              /*console.log('OBJ-->',Obj)
              this.getSecuenciaAlfNum()*/
          }else{
           this.imprimir(Obj, "etiqueta");
          }

                    });
                } else {
                  var resultado = {};
                  resultado.config = this.$store.getters.GetConfiguracionGeneral;
                  resultado.suplidor = this.imprimirEtiquetaXfact.suplidor;
                  resultado.cantidad = element.cantidad;
                  resultado.producto = res.data;
                  resultado.factura = e.referencia;
                  resultado.unidad = element.unidades.descripcion;
                  resultado.formatoBarra = this.form.imprimirEtiqueta.formatoBarra;
                  resultado.Impresora = this.form.imprimirEtiqueta.Impresora;
                  resultado.productoOpuesto = UNI_MINI;
                  if(element.fechavencimiento!=null){
                    resultado.fecha=this.getParamFecha(element.fechavencimiento)
                  }
                  this.imprimir(resultado, "etiqueta");
                }
              });

              })
          }
        });

      }
    },

    newwnuevo() {


this.form= {
        imprimirEtiqueta: {
          codigo: 0,
          producto: null,
          fecha: null,
          factura: "",
          suplidor: null,
          costo: 0,
          beneficio: 0,
          precio: 0,
          codigoBarra: null,
          Impresora: null,
          formatoBarra: null,
          unidad: "",
          cantidad:0,

        },
        ultimaSecControl:"",
        balancelote:null
      }

        EventBus.$emit("actualizaBarraBusqueda2")
      EventBus.$emit("loading", false)
    },


    getMonedaBase() {
      var MONEDA = JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
      this.objMoneda.moneda = MONEDA
      this.objMoneda.tasa = MONEDA.tasa
    },

    cargarMoneda() {
      this.$axios
        .get(this.$hostname + this.$hName + "/monedas/findallActivos/", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.Rmoneda = res.data))
    },
    SelctCbMoneda() {
      var _this = this
      setTimeout(function() {
        if (_this.objMoneda.moneda == null) {
          _this.objMoneda.moneda = ""
        }

        if (!_this.objMoneda.moneda.hasOwnProperty("codigo")) {
          _this.objMoneda.moneda = ""
          _this.objMoneda.moneda = null
          _this.getMonedaBase()
          return
        }
        //_this.objMoneda.tasa=_this.objMoneda.moneda.tasa
      }, 300)
    },

    getChangeMoneda(e) {
      if (typeof e === "object" && e != null && e.hasOwnProperty("codigo")) {
        this.objMoneda.tasa = e.tasa
      }

    },

    getSecuenciaAlfNum(){
//  var SEC=''
//  var CANT= this.form.imprimirEtiqueta.cantidad>0?this.form.imprimirEtiqueta.cantidad:1;
// for (let index = 0; index < CANT; index++) {
// if(index==0){
//   SEC=this.form.ultimaSecControl.trim().length>0?this.form.ultimaSecControl.trim():"AA0000"
// }
//   SEC = this.generarSecuencia(SEC).nuevaSecuencia
// console.log('SEC:-->',SEC)
// }
var CANT= this.form.imprimirEtiqueta.cantidad>0?this.form.imprimirEtiqueta.cantidad:1;
var SEC=this.form.ultimaSecControl.trim().length>0?this.form.ultimaSecControl.trim():"AA0000"
return this.generarSecuencia(SEC,CANT).nuevaSecuencia;

},

     generarSecuencia(secuenciaActual,cantAumento) {
    // Separar letras y números
    let letras = secuenciaActual.slice(0, 2);
    let numeros = parseInt(secuenciaActual.slice(2), 10);

    if(cantAumento>0){ numeros+=cantAumento}
    // Guardar la secuencia anterior
    const secuenciaAnterior = secuenciaActual;

    // Incrementar los números
    numeros++;

    if (numeros > 9999) {
        numeros = 1;

        // Incrementar las letras
        let primera = letras.charCodeAt(0);
        let segunda = letras.charCodeAt(1);

        segunda++;

        if (segunda > 90) { // 90 = 'Z'
            segunda = 65;   // 65 = 'A'
            primera++;
        }

        if (primera > 90) {
            // Reiniciar a AA0001 si pasa de ZZ
            primera = 65;
            segunda = 65;
        }

        letras = String.fromCharCode(primera) + String.fromCharCode(segunda);
    }

    // Formatear números con ceros a la izquierda
    const numerosStr = String(numeros).padStart(4, '0');

    // Nueva secuencia
    const nuevaSecuencia = letras + numerosStr;

    return { secuenciaAnterior, nuevaSecuencia };

    // Ejemplo de uso:
console.log(generarSecuencia("AA0364")); // { secuenciaAnterior: 'AA0364', nuevaSecuencia: 'AA0365' }
console.log(generarSecuencia("AA9999")); // { secuenciaAnterior: 'AA9999', nuevaSecuencia: 'AB0001' }
console.log(generarSecuencia("ZZ9999")); // { secuenciaAnterior: 'ZZ9999', nuevaSecuencia: 'AA0001' }
},


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)

        this.ejecucion = false
        EventBus.$emit("loading", false)
      }
    },
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
    },
  },

  computed: {
    ActDescBtn() {
      if (this.form.imprimirEtiqueta.codigo > 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: false,
          nuevo: true,
          guardar: false,
          eliminar: false,
          anular: false,
          imprimir: true,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
          etiquetaXfactura: true,
        }
      }

      if (this.form.imprimirEtiqueta.codigo <= 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: false,
          nuevo: true,
          guardar: false,
          eliminar: false,
          anular: false,
          imprimir: true,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
          etiquetaXfactura: true,
        }
      }
    },
  },
}
</script>

<style></style>
